import React from "react";
import { IconButton, Box, Typography } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import { useSelector, useDispatch } from "react-redux";
import actions from "../../Store/actions";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./styles";
import AssetStatusIcon from "./AssetStatusIcon";
import { useTypesListMake } from "../../common/hooks";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const SearchItem = ({ data, searchText, isLinked }) => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { typesList } = useSelector((state) => state);

    const params = useParams();
    const classes = makeStyles(styles)();
    const { assetAttributes, assetCore, id, isAssigned, isExpected } = data;

    /** Model id  of attrubute is 1
     *  Using id because of language translation
     */
    const modelId = 1;
    const modelAttribute = typesList.attributes.data.find(
        (item) => item.id === modelId
    );

    const modelValue =
        assetAttributes &&
        assetAttributes.find((item) => item.attribute === modelAttribute.id);
    const model = modelValue && modelValue.value ? modelValue.value : "";

    const { identifier1, identifier2, identifier3, identifier4, make } =
        assetCore;
    const makeIdentifier = useTypesListMake(make);
    const { auditId } = params;

    /** If the variantType is present text will have bigger font szie */
    const getParagraph = (children, variantType) => (
        <Typography
            component="p"
            variant={variantType === "body1" ? "body1" : "body2"}
            color={variantType === "body1" ? "text.secondary" : "text.darkText"}
            align="left"
        >
            {children}
        </Typography>
    );

    const generateText = (primaryText, variantType) => {
        const startIndex = primaryText.toLowerCase().indexOf(searchText);
        if (startIndex < 0) {
            return getParagraph(primaryText, variantType);
        }
        const endIndex = startIndex + searchText.length;
        const text = (
            <>
                {primaryText.substring(0, startIndex)}
                {
                    <Typography component="span" className={classes.searchText}>
                        {primaryText.substring(startIndex, endIndex)}
                    </Typography>
                }
                {primaryText.substring(endIndex)}
            </>
        );
        return getParagraph(text);
    };

    const onSearchListClick = () => {
        dispatch(actions.auditAssets.create.itemSet(data));
        navigate(`/auth/audits/${auditId}/assets/${id}/details`, {
            state: { linked: isLinked },
        });
    };

    return (
        <Box
            className={classes.searchList}
            onClick={!isAssigned && isExpected ? onSearchListClick : null}
            role="list"
        >
            {isAssigned && isExpected ? (
                <IconButton role="button" onClick={onSearchListClick}>
                    <EditOutlinedIcon
                        color="primary"
                        className={classes.editIcon}
                    ></EditOutlinedIcon>
                </IconButton>
            ) : null}
            <Box className={classes.textBox}>
                {identifier1 && generateText(identifier1, "body1")}
                {identifier2 && generateText(identifier2)}
                {identifier3 && generateText(identifier3)}
                {identifier4 && generateText(identifier4)}
                {makeIdentifier.name && generateText(makeIdentifier.name)}
                {model && generateText(model)}
            </Box>
            <AssetStatusIcon data={data} isLinked={isLinked}></AssetStatusIcon>
        </Box>
    );
};
export default SearchItem;
